import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useDevice } from '../Device';
import { Column } from './Column';
import { groupByColumn } from './ResponsiveStack.utils';
import { Row } from './Row';
export const ResponsiveStack = (param)=>{
    let { items, gap, className, columnClassName, testId } = param;
    const { isMobileDevice } = useDevice();
    if (isMobileDevice) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: items.map((item, index)=>/*#__PURE__*/ _jsx(React.Fragment, {
                    children: item.node
                }, index))
        });
    }
    return /*#__PURE__*/ _jsx(Row, {
        wrap: true,
        gap: gap,
        className: className,
        testId: testId,
        children: groupByColumn(items).map((columnNodes, index)=>/*#__PURE__*/ _jsx(Column, {
                gap: gap,
                className: columnClassName,
                children: columnNodes
            }, index))
    });
};
ResponsiveStack.displayName = 'ResponsiveStack';
